<template>
  <main class="register-screen">
    <v-container
      fluid
      class="register-container"
      :class="step != null && step > 1 ? 'wide' : ''"
    >
      <v-layout row wrap>
        <v-flex xs12 class="no-padding">
          <form-alert
            :type="alertText.type"
            :message="alertText.message"
            @close="closeFormAlert"
          ></form-alert>
        </v-flex>
        <div class="voltar-button">
          <a class="text--white" @click="handleBackButton">
            <svg viewBox="0 0 24 24">
              <path
                fill="#fff"
                d=" M20,10V14H11L14.5,17.5L12.08,19.92L4.16,12L12.08,4.08L14.5,6.5L11,10H20Z"
              />
            </svg>
            <span>Voltar</span>
          </a>
        </div>
        <v-flex xs12>
          <div class="main-title align-center">
            <p class="yellow--text mb-0 line-1">Seja nosso</p>
            <p class="white--text font-weight-black text-uppercase line-2">
              Parceiro
            </p>
            <p class="white--text mb-0 line-3" v-if="step == 1">
              Seja Bem Vindo à JNS Seguros!
              <br />Seu cadastro aqui é fácil e rápido!
            </p>
          </div>
        </v-flex>
        <v-flex
          :class="
            step == 1 ? 'offset-md2 md8 offset-sm1 sm10 full-height' : 'xs12'
          "
        >
          <!-- Cadastro inicial -->
          <v-form
            class="login-form"
            ref="formCNPJ"
            lazy-validation
            v-if="step == 1"
          >
            <v-flex xs12>
              <p
                class="blue--text text-xs-left font-weight-bold form-title-text"
              >
                Digite seu CNPJ para continuar
              </p>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                class="form-input-box"
                v-model="model.documento"
                v-mask="'##.###.###/####-##'"
                :rules="[rules.obrigatorio, rules.cnpjInvalido]"
                autofocus
              ></v-text-field>
            </v-flex>

            <button
              class="btn-primary jns-button yellow-button mt-5 register-button"
              v-html="'Continuar'"
              @click.stop.prevent="validaCampos()"
            ></button>
          </v-form>
          <!-- ./Cadastro inicial -->

          <!-- Dados -->
          <!-- Quadro de contato -->
          <v-card class="form-card mt-2 card-custom" v-if="step == 2">
            <v-container grid-list-xl>
              <v-card-title>
                <h2>
                  Administrador do sistema ou contato principal na corretora
                </h2>
              </v-card-title>

              <contato-component
                class="mt-4 ml-4 mr-4"
                ref="formAdministradorComponent"
                :representante="model.administrador"
                :showEmail="true"
                :showTelefone="true"
                :templateUser="true"
              ></contato-component>

              <v-flex xs12 class="pull-right mb-5 pr-4">
                <v-switch
                  v-model="temAssessoria"
                  label="Assessorado por terceiros?"
                  class="float-right"
                  @change="$forceUpdate()"
                ></v-switch>
              </v-flex>
            </v-container>
          </v-card>
          <!-- ./Quadro de contato -->

          <!-- Quadro de assessoria -->
          <v-card
            class="form-card mt-2 card-custom"
            v-if="step == 2 && temAssessoria"
          >
            <v-container grid-list-xl>
              <v-card-title>
                <h2>Dados da Assessoria</h2>
              </v-card-title>
              <v-form ref="formAssessoria" lazy-validation>
                <v-layout row wrap>
                  <v-flex md3 sm12>
                    <v-text-field
                      class="form-input-box"
                      label="CNPJ"
                      v-model="model.assessoria.cnpj"
                      v-mask="'##.###.###/####-##'"
                      :rules="[rules.obrigatorio, rules.cnpjInvalido]"
                      placeholder=" "
                    ></v-text-field>
                  </v-flex>

                  <v-flex md9 sm12>
                    <v-text-field
                      class="form-input-box"
                      label="Razão Social"
                      v-model="model.assessoria.nome"
                      :rules="[rules.obrigatorio]"
                      placeholder=" "
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card>
          <!-- ./Quadro de assessoria -->

          <!-- Quadro de Representante Técnico -->
          <v-card class="form-card mt-2 card-custom" v-if="step == 2">
            <v-container grid-list-xl>
              <v-card-title>
                <h2>
                  Representante Técnico
                  <span class="text-muted ml-2">(Perante SUSEP)</span>
                </h2>
              </v-card-title>

              <contato-component
                class="mt-4 ml-4 mr-4"
                ref="formRepresentanteSusepComponent"
                :representante="model.representante_susep"
                :showEmail="true"
                :showTelefone="true"
                :showCpf="true"
                :showSusep="true"
              ></contato-component>
            </v-container>
          </v-card>
          <!-- ./Quadro de Representante Técnico -->

          <!-- Quadro de dados -->
          <v-card class="form-card mt-2 card-custom" v-if="step == 2">
            <v-container grid-list-xl>
              <v-card-title>
                <h2>Dados da Empresa</h2>
              </v-card-title>
              <v-form ref="formDados" lazy-validation>
                <v-layout row wrap>
                  <v-flex md3 sm12>
                    <v-text-field
                      class="form-input-box"
                      label="CNPJ"
                      v-model="model.documento"
                      :readonly="true"
                      v-mask="'##.###.###/####-##'"
                      placeholder=" "
                    ></v-text-field>
                  </v-flex>

                  <v-flex md6 sm12>
                    <v-text-field
                      class="form-input-box"
                      label="Razão Social"
                      v-model="model.nome"
                      :title="model.nome"
                      :rules="[rules.obrigatorio]"
                      placeholder=" "
                    ></v-text-field>
                  </v-flex>

                  <v-flex md3 sm12>
                    <v-text-field
                      class="form-input-box"
                      label="Telefone Empresa"
                      v-model="model.telefone"
                      v-the-mask="['(##) #####-####', '(##) ####-####']"
                      :rules="[rules.obrigatorio, rules.telefone]"
                      placeholder=" "
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>

              <v-card-title>
                <h2>Endereço</h2>
              </v-card-title>

              <endereco-component
                :endereco="model.endereco"
                class="mt-4 ml-4 mr-4"
                ref="formEnderecoComponent"
              ></endereco-component>
            </v-container>
          </v-card>
          <!-- ./Quadro de dados -->

          <!-- Quadro de dados bancários -->
          <v-card class="form-card mt-2 card-custom" v-if="step == 2">
            <v-container grid-list-xl>
              <v-card-title>
                <h2>Dados Financeiros</h2>
              </v-card-title>

              <dados-financeiros-component
                class="ml-4 mr-4 mt-4"
                ref="formDadosFinaceirosComponent"
                :bancos="bancos"
                :item="model"
                :showCpom="true"
                :showRepFinanceiro="true"
                :sublabelDadosBancarios="'(Vinculado ao CNPJ da corretora)'"
              ></dados-financeiros-component>
            </v-container>
          </v-card>
          <!-- ./Quadro de dados bancários -->
          <!-- ./Dados -->

          <!-- Representantes legais-->
          <v-card class="form-card mt-2 card-custom" v-if="step == 3">
            <v-container grid-list-xl>
              <v-card-title>
                <h2>
                  Representantes Legais
                  <span class="text-muted ml-2"
                    >(conforme contrato social)</span
                  >
                </h2>
              </v-card-title>
              <pessoa-politicamente-exposta-component
                class="ml-4 mr-4 mt-4"
                ref="formRepresentanteComponent"
                :representantesLegais="model.representantes_legais"
                :categoriasPeps="categoriasPeps"
                @validaCategoriaPep="validaCategoriaPep"
              ></pessoa-politicamente-exposta-component>
            </v-container>
          </v-card>
          <!-- ./Representantes legais-->

          <!-- Anexo -->
          <v-card
            class="form-card mt-2 card-custom"
            v-show="step == 4"
            v-if="
              model.documentos_solicitados &&
                model.documentos_solicitados.length > 0
            "
          >
            <v-container grid-list-xl>
              <v-card-title>
                <h2>Upload de Documentos</h2>
              </v-card-title>

              <anexo-list-component
                class="ml-4 mr-4 mt-4"
                :documentosSolicitados.sync="model.documentos_solicitados"
                :classColuna="'lg4 md6 sm12'"
                :mostraDescricao="true"
                :mostraTitulo="
                  model.documentos_solicitados &&
                    model.documentos_solicitados.length > 1
                "
                @send="setUpdateDocumentos"
                @setDocumentosModel="cadastrarCorretor"
              />
            </v-container>
          </v-card>
          <!-- ./Anexo -->

          <!-- Questionamento -->
          <v-card class="form-card mt-2 card-custom" v-if="step == 5">
            <v-container grid-list-xl>
              <v-flex xs12>
                <v-form
                  ref="formQuestionario"
                  lazy-validation
                  v-for="(categoria, indexCategoria) in questionario"
                  :key="indexCategoria"
                >
                  <v-flex xs12 v-if="categoria.tipo == 'radio'">
                    <v-layout
                      row
                      wrap
                      v-for="(pergunta, index) in categoria.perguntas"
                      :key="index"
                    >
                      <v-flex xs12 v-if="index == 0">
                        <p class="questionario">
                          Para melhor atender as necessidade da sua realidade de
                          negócios, conte-nos um pouco sobre sua experiência com
                          seguro garantia
                        </p>
                      </v-flex>

                      <v-flex
                        xs12
                        v-if="
                          index == 0 || categoria.perguntas[0].resposta == 'sim'
                        "
                      >
                        <p class="mb-0 pb-0 custom-label label_text">
                          {{ pergunta.titulo }}
                        </p>
                        <v-radio-group
                          row
                          class="mb-0 pb-0"
                          v-model="pergunta.resposta"
                          :rules="index == 0 ? [rules.obrigatorio] : []"
                        >
                          <v-radio
                            v-for="(opcao, indexOp) in pergunta.opcoes"
                            :key="indexOp"
                            :label="opcao.label"
                            :value="opcao.valor"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex
                    xs12
                    v-if="
                      categoria.tipo == 'select' &&
                        questionario[0].perguntas[0].resposta == 'sim'
                    "
                  >
                    <v-layout
                      row
                      wrap
                      v-for="(pergunta, index) in categoria.perguntas"
                      :key="index"
                    >
                      <v-flex xs12>
                        <p class="mb-0 pb-0 custom-label label_text">
                          {{ pergunta.titulo }}
                        </p>
                      </v-flex>

                      <v-flex md5 sm12>
                        <v-select
                          v-model="pergunta.resposta"
                          :items="pergunta.opcoes"
                          class="form-select-box mt-0 pt-0"
                          placeholder="Selecionar"
                          :rules="[rules.questionarioSelect]"
                          multiple
                        >
                          <template slot="selection" slot-scope="data">
                            <v-chip
                              :selected="data.selected"
                              v-if="data.index === 0"
                            >
                              <span>{{ data.item }}</span>
                            </v-chip>
                            <span
                              v-if="data.index === 1"
                              class="grey--text caption"
                            >
                              (+{{ pergunta.resposta.length - 1 }}
                              outros)
                            </span>
                          </template>
                        </v-select>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 v-if="categoria.tipo == 'check'">
                    <v-layout row wrap>
                      <v-flex
                        xs12
                        pt-0
                        pb-0
                        v-for="(pergunta, index) in categoria.perguntas"
                        :key="index"
                      >
                        <div class="container-checkbox">
                          <v-checkbox
                            class="mt-0 mb-0"
                            v-model="pergunta.resposta"
                            value="sim"
                            type="checkbox"
                            @change="mostraErroQuestionarioCheck = true"
                            :rules="[
                              (v) =>
                                validadorQuestionarioCustomizado(v, index) ||
                                '',
                            ]"
                          ></v-checkbox>
                          <p
                            :class="
                              mostraErroQuestionarioCheck && pergunta.hasError
                                ? 'error--text'
                                : ''
                            "
                            v-html="pergunta.titulo"
                          ></p>
                        </div>
                        <p
                          v-if="mostraErroQuestionarioCheck & pergunta.hasError"
                          class="v-messages error--text"
                        >
                          Campo obrigatório
                        </p>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-form>
              </v-flex>
            </v-container>
          </v-card>
          <!-- ./Questionamento -->
        </v-flex>

        <v-flex md3 offset-md9 sm12 mt-4 mb-3>
          <button
            @click="validaCampos()"
            class="button jns-button yellow-button"
            v-if="step > 1"
          >
            {{ step != 5 ? "Continuar" : "Finalizar Cadastro" }}
          </button>
        </v-flex>
      </v-layout>

      <v-dialog
        v-model="registerSuccessModal"
        persistent
        :max-width="'507'"
        v-if="step > 1"
      >
        <main id="selecionar-empresa" class="ohx login-modal">
          <v-content class="ohx">
            <v-container fluid grid-list-xs class="white-background ohx pb-4">
              <v-layout row wrap>
                <v-flex xs12 text-xs-center>
                  <h1>
                    <v-icon class="material-icons icon-color"
                      >check_circle</v-icon
                    >
                  </h1>
                </v-flex>

                <v-flex xs12 text-xs-center>
                  <h2 class="title">Cadastro Finalizado</h2>
                  <p class="description mt-4">
                    Seu cadastro foi concluído e está em análise.
                  </p>
                  <p class="description mt-3">
                    Aguarde instruções de proximos passos no e-mail
                    <a
                      v-if="model && model.administrador.email"
                      :href="'mailto:' + model.administrador.email"
                      >{{ model.administrador.email }}</a
                    >
                  </p>
                </v-flex>
                <v-flex md3 offset-md9 sm12>
                  <button
                    @click="$router.push({ name: 'Login' })"
                    class="button jns-button yellow-button"
                  >
                    OK
                  </button>
                </v-flex>
              </v-layout>
            </v-container>
          </v-content>
        </main>
      </v-dialog>
    </v-container>
  </main>
</template>

<script lang="js">
import { eventBus } from "../../../main";
import { VMoney } from "v-money";
import { mask } from "vue-the-mask";
import { upload } from "@/services/fake.file-upload.service";
import config from "@/../config";
import PictureInput from "vue-picture-input";
import ViewMixin from "@/mixins/ViewMixin";
import { isValidCnpj } from "@/libs/utils";

const cepRegex = new RegExp("\\d{5}[-]\\d{3}");
const telefoneRegex = /^(\([0-9]{2}\))\s([9]{1})?([0-9]{4})-([0-9]{4})$/;
const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

export default {
  nome: "Cadastrar",
  components: {
    PictureInput,
  },
  mixins: [ViewMixin],
  directives: { money: VMoney, "the-mask": mask },
  data: () => ({
    mostraModalCategoriasPep: false,
    registerSuccessModal: false,
    mostraErroQuestionarioCheck: false,
    temAssessoria: false,
    step: 1,
    indexRepresentante: 0,
    moneyConfig: {},
    model: {
      documento: "",
    },
    rules: {
      obrigatorio: (v) => !!v || "Campo obrigatório",
      obrigatorioCategoria: (v) => !!v || v.length > 0 || "Campo obrigatório",
      email: (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail inválido",
      telefone: (v) =>
        /^(\([0-9]{2}\))\s([9]{1})?([0-9]{4})-([0-9]{4})$/.test(v) ||
        "Telefone inválido",
      cnpjInvalido: (v) => (!!v && isValidCnpj(v)) || "CNPJ inválido",
      questionarioSelect: (v) =>
        !v || v.length <= 3 || "Não é permitido selecionar mais de três opções",
    },
    pendencias: [],
    categoriasPeps: [],
    bancos: [],
    estados: [],
    questionario: [
      {
        tipo: "radio",
        perguntas: [
          {
            uuid: "5b754e7b-46f1-4b20-891b-d1dcedec9107",
            titulo: "Você já trabalha com seguro garantia?",
            resposta: null,
            opcoes: [
              { label: "Sim", valor: "sim" },
              { label: "Não", valor: "nao" },
            ],
          },
          {
            uuid: "5a6b0efe-2cee-4a56-a812-c5d15f8091eb",
            titulo: "Qual a sua produção anual média com seguro garantia?",
            resposta: null,
            opcoes: [
              {
                label: "Prêmios abaixo de 500.000",
                valor: "Abaixo de 500.000",
              },
              {
                label: "Prêmios entre 500.000 e 1.000.000",
                valor: "Entre 500.000 e 1.000.000",
              },
              {
                label: "Prêmios acima de R$ 1.000.000",
                valor: "Acima de R$ 1.000.000",
              },
            ],
          },
        ],
      },
      {
        tipo: "select",
        perguntas: [
          {
            uuid: "59cb1649-682e-4e43-8ef2-ac8a093be6ca",
            titulo: "Quais destas modalidades de operação você mais emite?",
            resposta: null,
            opcoes: [
              "Exec. Construtor",
              "Exec. Fornecedor",
              "Exec. Prestador de Serviços",
              "Retenção de Pagamento",
              "Judicial Deposito Recursal",
              "Judicial Substituicao Deposito Recursal",
              "Cobertura ad. Trabalhista e Previdenciária",
              "Cobertura ad. Fiscal e Tributaria",
              "Adiantamento de Pagamento",
              "Licitante (não concessão/ Aneel)",
            ],
          },
        ],
      },
      {
        tipo: "check",
        perguntas: [
          {
            uuid: "a1f2925c-6c82-4882-a45c-4d747bb6ca60",
            titulo:
              "A validade do cadastro do Corretor de Seguros está condicionada ao correto preenchimento deste formulário, em conformidade com a legislação aplicável.",
            resposta: null,
          },
          {
            uuid: "a92151b2-bb53-4c07-9be9-403be71cf24b",
            titulo:
              "Declaro, para os devidos fins, que li o <a href='https://www.jnsseguros.com.br/views/geral/img/Cartilha-Codigo-de-Etica-JNS-VF.pdf' target='_blank'>Código de Ética e Conduta da JNS Seguradora</a>, compreendendo e estando de acordo com todos os seus termos, comprometendo-me a colaborar com o efetivo cumprimento das diretrizes previstas no referido código, bem como toda a legislação aplicável à relação, incluindo a Lei Geral de Proteção de Dados (Lei nº 13.709/2018), tão logo entre em vigor.",
            resposta: null,
          },
        ],
      },
    ],
  }),
  computed: {
    situacao: function () {
      if (this.model != null)
        return this.model.situacao_susep ? "Ativo" : "Inativo";
      else return "Inativo";
    },
  },
  methods: {
    /* consultas assincronas */
    async cadastrarCorretor(modelDocumentos) {
      let t = this;
      let data;

      try {
        t.$store.commit("SET_LOADING_INDICATOR_FLAG", true);
        data = await t.$store.dispatch(
          "INSERT_CORRETOR",
          this.setCorretorSalvar(modelDocumentos)
        );
      } catch (e) {
        t.$store.commit("SET_LOADING_INDICATOR_FLAG", false);

        t.loadingFromBackendModal = false;
        if (e.data) t.cnpjError = e.data;
        else if (e.response && e.response.data) t.cnpjError = e.response.data;
        if (!t.cnpjError) t.cnpjError = {};
        if (!t.cnpjError.title) t.cnpjError.title = "Erro Indefinido";
        if (!t.cnpjError.message)
          t.cnpjError.message = "Por favor, contate o administrador";

        this.setErrorModal({
          title: t.cnpjError.title,
          message: t.cnpjError.message,
        });

        return;
      }

      t.$store.commit("SET_LOADING_INDICATOR_FLAG", false);

      if (data) {
        t.registerSuccessModal = true;
        t.$forceUpdate();
      }
    },

    async getBankList() {
      try {
        this.showLoadingAskWait();
        this.bancos = await this.$store.dispatch("GET_BANK");
      } catch (e) {
        this.setErrorModal(e.response.data);
      } finally {
        this.hideLoadingAskWait();
      }
    },

    async checkDocument() {
      let t = this;
      let data;

      try {
        this.showLoadingAskWait();
        data = await t.$store.dispatch("CHECK_DOCUMENTV2", {
          document: t.model.documento.replace(/[^\w\s]/gi, ""),
        });
      } catch (e) {
        //console.error(e);
        if (!e.response || e.response.data == null) {
          let data = {
            code: 5019,
            title: "Falha ao realizar consulta",
            message:
              "Ocorreu um problema na consulta pública, favor tentar novamente mais tarde.",
            details: null,
          };
          this.setErrorModal(data);
          return;
        } else {
          this.setErrorModal(e.response.data);
          return;
        }
      } finally {
        this.hideLoadingAskWait();
      }

      if (data.status != "NAO_CADASTRADO") {
        var erro = {};

        if (data.status == "APROVADO") {
          erro.titulo = "CNPJ já Cadastrado";
          erro.mensagem = "Esta corretora já está cadastrada. ";
        } else if (data.status == "EM_ANALISE") {
          erro.titulo = "CNPJ em Análise";
          erro.mensagem = "Esta corretora está em análise. ";
        } else if (data.status == "REPROVADO") {
          erro.titulo = "CNPJ Reprovado";
          erro.mensagem = "Esta corretora foi reprovada. ";
        } else {
          erro.titulo = "Erro";
          erro.mensagem = "";
        }

        this.setErrorModal({
          title: erro.titulo,
          message:
            erro.mensagem +
            'Entre em contato com o e-mail <a href="mailto:sac@jnsseguros.com.br">sac@jnsseguros.com.br</a>  para mais informações.',
        });

        return;
      }

      t.$store.commit("SET_ALERT_TEXT", {
        type: "success",
        message:
          "Seus dados de cadastro foram carregados com sucesso, conforme informações obtidas da SUSEP.",
      });

      t.alertText = t.handleAlertText();
      t.$forceUpdate();
      this.hideLoadingIndicator();

      t.model = data;
      t.model.administrador = { nome: "", email: "", telefone: "" };
      t.model.assessoria = { nome: "", cnpj: "" };
      t.model.representante_susep = { nome: "", email: "", telefone: "" };
      t.model.contato_financeiro = { nome: "", email: "", telefone: "" };
      t.model.diretor_financeiro = { nome: "", cpf: "" };
      if (!t.model.dados_bancarios) t.model.dados_bancarios = {};
      if (!t.model.endereco) t.model.endereco = {};
      t.step++;

      let tel = t.model.telefone;
      if (tel != null) {
        let formattedTel;
        if (tel.length === 10) {
          formattedTel = `(${tel.slice(0, 2)}) ${tel.slice(2, 6)}-${tel.slice(
            6,
            10
          )}`;
        }
        if (tel.length === 11) {
          formattedTel = `(${tel.slice(0, 2)}) ${tel.slice(2, 7)}-${tel.slice(
            7,
            11
          )}`;
        }
        // Telefone contato e telefone da empresa
        t.model.administrador.telefone = formattedTel;
        t.model.telefone = formattedTel;
      }

      if (
        !t.model.representantes_legais ||
        t.model.representantes_legais.length == 0
      )
        t.model.representantes_legais.push({
          nome: null,
          documento: null,
          cargo: null,
          pep: false,
          categorias_pep: [],
          categorias_pep_selected: [],
        });

      this.model.representantes_legais.forEach((representante) => {
        if (
          representante.categorias_pep &&
          representante.categorias_pep.length > 0
        )
          representante.categorias_pep.forEach((item) => {
            this.categoriasPeps.forEach((element) => {
              if (element.id == item.id)
                representante.categorias_pep_selected.push(element);
            });
          });
      });

      this.questionario.forEach((element) => {
        element.resposta = null;
      });
    },

    async getCategoriasPep() {
      var data = [];
      try {
        this.showLoadingAskWait();
        data = await this.$store.dispatch("GET_CATEGORIAS_PEP");
      } catch (e) {
        this.setErrorModal(e.response.data);
        return;
      } finally {
        this.hideLoadingAskWait();
      }

      if (data)
        for (var i = 0; i < data.length; i++)
          this.categoriasPeps.push({
            id: data[i].id,
            descricao: data[i].descricao,
            enumerador: i + 1,
            tooltipShow: false,
          });
    },

    handleBackButton() {
      let t = this;
      if (t.step == 1) {
        t.$router.push({ name: "Login" });
      } else {
        t.step--;
      }
    },

    setCorretorSalvar(modelDocumentos) {
      var modelPercist = {
        nome: this.model.nome,
        documento: this.model.documento.replace(/[^\w\s]/gi, ""),
        cpom: this.model.cpom,
        simples_nacional: this.model.simples_nacional,
        dados_bancarios: this.model.dados_bancarios,
        situacao_patrimonial: this.model.situacao_patrimonial,
        telefone: this.model.telefone.replace(/[^\w\s]/gi, ""),
        endereco: {
          logradouro: this.model.endereco.logradouro,
          bairro: this.model.endereco.bairro,
          cidade: this.model.endereco.cidade,
          uf: this.model.endereco.uf,
          cep: this.model.endereco.cep,
        },
        administrador: {
          nome: this.model.administrador.nome,
          email: this.model.administrador.email.toLowerCase(),
          telefone: this.model.administrador.telefone.replace(/[^\w\s]/gi, ""),
        },
        diretor_financeiro: !this.model.diretor_financeiro.cpf
          ? null
          : {
              nome: this.model.diretor_financeiro.nome,
              cpf: this.model.diretor_financeiro.cpf.replace(/[^\w\s]/gi, ""),
            },
        representante_susep: {
          nome: this.model.representante_susep.nome,
          cpf: this.model.representante_susep.cpf.replace(/[^\w\s]/gi, ""),
          email: this.model.representante_susep.email.toLowerCase(),
          telefone: this.model.representante_susep.telefone.replace(
            /[^\w\s]/gi,
            ""
          ),
          numero_susep: this.model.representante_susep.numero_susep,
        },
        contato_financeiro: {
          nome: this.model.contato_financeiro.nome,
          email: this.model.contato_financeiro.email.toLowerCase(),
          telefone: this.model.contato_financeiro.telefone.replace(
            /[^\w\s]/gi,
            ""
          ),
        },
        assessoria: this.temAssessoria
          ? {
              nome: this.model.assessoria.nome,
              cnpj: this.model.assessoria.cnpj.replace(/[^\w\s]/gi, ""),
            }
          : { nome: "", cnpj: "" },
        representantes_legais: [],
        questionario: [],
        documentos: modelDocumentos,
      };

      this.model.representantes_legais.forEach((element) => {
        var item = {
          nome: element.nome,
          documento: element.documento,
          cargo: element.cargo,
          pep: element.pep,
          categorias_pep: [],
        };

        element.categorias_pep.forEach((elementCat) => {
          item.categorias_pep.push({ id: elementCat.id });
        });

        modelPercist.representantes_legais.push(item);
      });

      this.questionario.forEach((categoria) => {
        categoria.perguntas.forEach((element) => {
          var resposta = "";

          if (categoria.tipo == "select" && element.resposta)
            resposta = element.resposta.toString();
          else resposta = element.resposta || "";

          modelPercist.questionario.push({
            id: element.uuid,
            titulo: element.titulo,
            resposta: resposta,
          });
        });
      });

      return modelPercist;
    },

    setUpdateDocumentos(data) {
      this.model.documentos_solicitados = data;
      this.$forceUpdate();
    },

    validaCampos() {
      var isValid = true;

      switch (this.step) {
        case 1:
          if (this.$refs.formCNPJ.validate()) this.checkDocument();
          break;
        case 2:
          var administradorForm = this.$refs.formAdministradorComponent;
          var representanteSusepForm = this.$refs
            .formRepresentanteSusepComponent;
          var enderecoForm = this.$refs.formEnderecoComponent;
          var dadosFinaceirosForm = this.$refs.formDadosFinaceirosComponent;
          var dadosCpomForm = dadosFinaceirosForm.$refs.formDadosCpomComponent;
          var representanteFinaceiroForm =
            dadosFinaceirosForm.$refs.formRepresentanteFinanceiroComponent;

          if (!administradorForm.$refs.formContato.validate()) isValid = false;
          if (!representanteSusepForm.$refs.formContato.validate())
            isValid = false;
          if (!this.$refs.formDados.validate()) isValid = false;
          if (!enderecoForm.$refs.formEndereco.validate()) isValid = false;
          if (
            this.model.cpom == false &&
            !dadosCpomForm.$refs.formContato.validate()
          )
            isValid = false;
          if (!representanteFinaceiroForm.$refs.formContato.validate())
            isValid = false;
          if (!dadosFinaceirosForm.$refs.formDadosFinanceiros.validate())
            isValid = false;
          if (!dadosFinaceirosForm.$refs.formDadosBancarios.validate())
            isValid = false;
          if (this.temAssessoria && !this.$refs.formAssessoria.validate())
            isValid = false;

          if (isValid) this.step++;
          else this.$forceUpdate();

          break;
        case 3:
          var representanteForm = this.$refs.formRepresentanteComponent;
          for (
            var i = 0;
            i < representanteForm.$refs.formRepresentante.length;
            i++
          ) {
            if (!representanteForm.$refs.formRepresentante[i].validate())
              isValid = false;

            var categoriaIsValid = this.validaCategoriaPep(i);

            if (!categoriaIsValid && isValid) isValid = false;
          }

          if (isValid)
            if (
              this.model.documentos_solicitados &&
              this.model.documentos_solicitados.length
            ) {
              this.step++;
            } else this.step += 2;
          else this.$forceUpdate();

          break;
        case 4:
          if (this.validaAnexos()) this.step++;
          else this.$forceUpdate();
          break;
        case 5:
          this.$refs.formQuestionario.forEach((element) => {
            if (!element.validate()) {
              isValid = false;
              this.mostraErroQuestionarioCheck = true;
            }
          });

          if (isValid) eventBus.$emit("setModelAnexos");
          else this.$forceUpdate();

          break;
        default:
          break;
      }
    },

    validaCategoriaPep(i) {
      var isValid = true;

      if (this.model.representantes_legais[i].pep)
        if (
          !this.model.representantes_legais[i].categorias_pep_selected ||
          this.model.representantes_legais[i].categorias_pep_selected.length ==
            0
        ) {
          this.$set(this.model.representantes_legais[i], "hasError", true);
          isValid = false;
        } else
          this.$set(this.model.representantes_legais[i], "hasError", false);

      return isValid;
    },

    validaAnexos() {
      var isValid = true;

      this.model.documentos_solicitados.forEach((categoria) => {
        if (categoria.listagem && categoria.listagem.length) {
          for (var i = 0; i < categoria.listagem.length; i++) {
            if (
              (!categoria.listagem[i].arquivos ||
                !categoria.listagem[i].arquivos.length) &&
              categoria.listagem[i].obrigatorio
            )
              isValid = false;
          }
        }
      });
      if (!isValid) eventBus.$emit("validaAnexos");
      return isValid;
    },

    validadorQuestionarioCustomizado(v, index) {
      this.questionario.forEach((categoria) => {
        if (categoria.tipo == "check" && index >= 0)
          categoria.perguntas[index].hasError = !v;
      });

      this.$forceUpdate();

      return !!v;
    },
  },
  mounted() {
    let t = this;
    t.step = 1;
    t.moneyConfig = this.$settings.moneyConfig;
    t.estados = this.$settings.estados;

    t.getCategoriasPep();
    t.getBankList();
  },

  watch: {
    temAssessoria: function (newValue) {
      if (!newValue) this.model.assessoria = { nome: "", cnpj: "" };
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 600px) {
  .sm12 {
    width: 100% !important;
  }

  .login-form {
    padding: 4vh !important;

    .form-title-text {
      font-size: 2.2vh !important;
    }
  }

  .line-3 {
    font-size: 2.2vh !important;
  }

  .container {
    padding: 1vh !important;
  }

  .float-right {
    float: none !important;
  }

  .v-input {
    font-size: 2.2vh !important;
  }

  .container-card-categoria-pep {
    .card-categoria-pep {
      height: 50% !important;
      overflow: auto;
    }
  }

  .pep-button {
    margin-top: 1vh;
  }
}

.v-label {
  font-size: 1.3vh !important;
}

#jns {
  .form-card .container {
    max-width: 100% !important;
  }

  .login-form {
    margin: 0;
  }

  .wide {
    max-width: 90% !important;
  }
  .contact-row {
    border-bottom: 0.1vh solid #eee;
  }
  .v-card {
    .card_container {
      width: 80vh !important;
      margin-left: -8vh !important;
    }
  }
  .label_text {
    font-size: 2vh;
  }

  .questionario {
    font-size: 2.5vh;
  }
  h1 {
    color: #282498;
    font-size: 2.6vh;
    font-weight: bold;
  }
  h3 {
    font-weight: normal;
  }

  .email-susep {
    color: #4589f3;
  }
  .loading-animation {
    width: 77%;
    height: 7.7vh;
    display: block;
    margin: 0 auto;
    margin-bottom: 3vh;
  }
  .stepper {
    background-color: transparent;
    box-shadow: none;
  }
  .info-icon {
    color: #191737;
    cursor: pointer;
    margin-top: -0.5vh;
    margin-left: 0.5vh;
  }

  .divider {
    background: #fff;
  }
  .font-weight-bold {
    font-weight: bold;
    color: #333;

    width: 100%;
  }
  .text--white {
    color: #fff;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .title-categoria-pep {
    text-align: center;
    margin-bottom: 5vh;
    color: #061d45;
  }
  .container-card-categoria-pep {
    height: 60vh;
    overflow: auto;
    .card-categoria-pep {
      margin-bottom: 3vh;
      padding: 1vh;
      height: 13vh;

      .layout-categoria-pep {
        height: 8vh;

        .flex-categoria {
          padding: 3.3vh 2vh;

          .content-enumerador {
            text-align: center;
            font-weight: bold;
            background-color: #28249852;
            color: #282498;
            font-size: 3vh;
            height: 4vh;
            width: 4vh;
          }

          .content-icon-check {
            font-size: 5vh;
            color: #282498;
          }

          .content-icon-no-check {
            font-size: 5vh;
          }
        }

        .flex-categoria-pep {
          font-size: 1.8vh;
          height: 8vh;
        }
      }
    }
  }

  .v-chip {
    background-color: #28249852;
    color: #282498;
    font-weight: bold;
    border-radius: 0;
    font-size: 1.8vh;
  }

  .chip--select-multi {
    font-size: 3vh !important;
  }

  .icon-color {
    color: #282498;
  }
}

.v-footer {
  position: fixed;
  z-index: 999;
  bottom: 5.1%;
  width: 115vh;
  padding-right: 3.3%;
  padding: 0 7vh 1.5vh 0;
  height: 4.6vh !important;
  background: #fff;
}

.add-new-contact {
  font-size: 2.2vh !important;
  color: #4589f3;
  font-weight: bold;
  text-decoration: none;
  margin: 1vh 1vh 1vh 2vh !important;
  display: inline-block;
  i {
    color: #4589f3;
    margin-top: -0.3vh;
  }
}

.form-card {
  box-shadow: none;
  margin-left: -2.4vh;
  margin-right: -2.4vh;
  .card__title {
    padding-left: 2.4vh;
    padding-right: 2.4vh;
  }
  .layout {
    margin: 0 !important;
    &.no-padding {
      padding: 0;
    }

    padding: 0.4vh;
    padding-left: 1.2vh;
    padding-right: 1.2vh;
  }

  .card__title {
    background-color: #efefef;
    font-size: 1.6vh;
    font-weight: bold;
    color: #191737;
  }

  .dropbox {
    outline: 0.2vh dashed #c2c2c2; /* the dash box */
    outline-offset: -1vh;
    color: dimgray;
    padding: 1vh 1vh;
    min-height: 8.5vh; /* minimum height */
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 20vh;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: #eee; /* when mouse over to the drop zone, change color */
  }

  .dropbox p {
    font-size: 1.2vh;
    text-align: center;
    padding: 5vh 0;
    color: #a5a5a5;
    font-size: 1.4vh;
    font-weight: bold;
  }
  .text--white {
    a {
      font-weight: bold;
      color: #fff !important;
      svg path {
        fill: #fff !important;
      }
    }
  }
}

.line {
  &-1,
  &-3 {
    font-size: 2.4vh;
    font-weight: bold;
    letter-spacing: 0.2vh;
    line-height: 4.8vh;
    text-align: center;
    text-shadow: 0 0.3vh 1.5vh 0 rgba(0, 0, 0, 0.37);
  }
  &-2 {
    text-align: center;
    font-size: 8vh;
    letter-spacing: 0.6vh;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  &-3 {
    line-height: 3.5vh;
  }
}

.register-broker__white-background {
  background-color: white;
  color: #555;
  margin-top: -5.7vh;
  padding-top: 5.7vh !important;
}

.form-title-text {
  font-size: 2.5vh;
}

.add-new-contact {
  font-size: 1.4vh;
  color: #282498;
  font-weight: bold;
  text-decoration: none;
  margin-top: 0.3vh;
  display: inline-block;
  i {
    color: #282498;
    margin-top: -0.3vh;
  }
}

.close_icon {
  color: #d21a5e;
}

.flex-close {
  float: right;
  height: -webkit-fill-available;
}

.margin-auto {
  margin: auto;
}

.card-custom {
  border-bottom: 0.5vh solid #f1e41e;
  border-radius: 0.5vh;
}

.v-card__title h2 {
  color: #061d45 !important;
}

.container-checkbox {
  display: inline-flex;

  .v-input--checkbox {
    position: absolute;
  }

  p {
    padding-left: 3vh;
    padding-top: 0.5vh;
    font-size: 1.5vh;
  }

  .v-messages {
    visibility: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/Corretores/Cadastrar.vue